import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _RequestTypeBpmAccount, _single } from "../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../theme/Component/PrintJson";

interface Config {
    _label?: string;
    returnType?: "Object" | "ID"
}

interface Props {
    idSelector: number;
    onChange: Function;
    _ConfigOptions?: Config;
}

export const SelectBPMRequestProcedureByAccount = ({ idSelector, onChange, _ConfigOptions }: Props) => {

    const { instance, lista, setLista } = useDataBean(_RequestTypeBpmAccount)
    const [id, setID] = useState(null);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        instance.getRequestTypeBpmCatalogByIDAccount(_single.getAccountID()).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDRequestTypeBpm == e
            );
            if (selectedItem) {
                onChange(_ConfigOptions?.returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(_ConfigOptions?.returnType === "Object" ? {} : null);
            }
        }
    };

    return (
        <>
            <label>{_ConfigOptions?._label ?? "Procedimiento"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDRequestTypeBpm} >{item.DataBeanProperties.Code} - {item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}